import Tables from 'src/class/Tables';
import i18n from 'src/i18n'

const configTable = () => {
  const businessTable = { ...Tables.Table };
  businessTable.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.company'),
      sortable: true,
      fixed: true,
      minWidth: 150,
    },
  ];


  const weekTable = { ...Tables.Table };
  weekTable.tableColumns = [
    ...Array.from({ length: 15 }, (_, i) => i + 1 ).map((item) => {
      return {
        prop: `week_${item}`,
        label: `${item} ${i18n.t('common_words.week_short')}`,
        minWidth: 90,
      };
    }),
    {
      prop: 'youths',
      label: i18n.t('production.young'),
      minWidth: 100,
    },
    {
      prop: 'bacotas',
      label: i18n.t('production.banana_flowers'),
      minWidth: 100,
    },
  ];


  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 100,
    },
  ];

  return { Table, businessTable, weekTable };
};

export default configTable;
